import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { EnumTotemType } from '@/pages/StoreManagement/states';
import api from '../../../services/api';
import queryClient from '../../queryClient';
import { QUERY_EXCEL_EXPORT } from '../../salles/GetExcel/useExcelExport';
import { InventoryType } from '../useStoreManagement';

interface PropsExcel {
    group?: string[] | null;
    name?: string;
    shopmanagerId?: number;
    shopmanagerEmail?: string;
    city?: string;
    state?: string;
    stores?: Array<number>;
    referenceDate?: string;
    totem?: boolean;
    active?: boolean;
    initialDate?: string;
    finalDate?: string;
    storeId?: number;
    totemEnum?: EnumTotemType;
    productIds?: Array<number>;
    timezone?: string;
    includeDeleted?: boolean;
    open?: boolean;
    reportType?: string;
    productName?: string;
    categoryId?: number;
    isTotemAuthenticated?: boolean | null;
    inventory?: InventoryType[];
}

const createExcellExportFetch = async (data: PropsExcel) => {
    const response = await api.post(`/reports/v2/export-xlsx`, {
        ...data,
    });
    return response.data;
};

export const useReport = () => {
    return useMutation({
        mutationFn: (data: PropsExcel) => createExcellExportFetch(data),
        onError: (error: AxiosError) => error,
        onSuccess: () => {
            queryClient.invalidateQueries([QUERY_EXCEL_EXPORT]);
        },
    });
};
